module.exports = __webpack_public_path__ + "img/lama.41be9cc8.webp";